module.exports = __webpack_public_path__ + "img/solid_paqueteria.24462d69.svg";